import { Link } from 'react-router-dom';
import Button from './Button';
import TextInfo from '../text/TextInfo';
import { useLanguage } from '../../context/LanguageContext';

function SurveyInfo() {
  const { t } = useLanguage();

  return (
    <section className="px-8">
      <div className="flex flex-col items-center justify-center border-b-2 border-gray">
        <h2 className="font-bold sm:text-4xl text-3xl text-center">
          <span className="text-blue">{t('take')}</span> <span className="text-red">{t('our')}</span>{' '}
          <span className="text-yellow">{t('survey')}</span>
          <span className="text-green">!</span>
        </h2>
        <br />
        <br />
        <TextInfo
          hasTitle={false}
          title="Survey information"
          isContentText={true}
          content={t('surveyInformation')}
        />
        <br />
        <br />
        <Link to="/survey">
          <Button text={t('answerShortSurvey')} />
        </Link>
        <br />
        <br />
        <br />
        <br />
      </div>
    </section>
  );
}

export default SurveyInfo;
